export default __webpack_public_path__ + "static/media/icn-locked.227a058d.svg";